var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fulfillment-hero"},[_c('hero-image',{staticClass:"fulfillment-hero__banner",attrs:{"alt":"Fulfillment","src":_vm.imageSrc,"fallback-src":_vm.imageFallbackSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }